/* ==============================================================================
   LUZGURU PRODUCT WISHLIST SYSTEM - CORE LOGIC
   Asset: assets/lg-wishlist.js
   Supports global wishlist drawer synced with local storage.
   ============================================================================== */

(function() {
  const STORAGE_KEY = 'lg-wishlist-products';

  // Escape para interpolar datos dentro de innerHTML (compartido con compare.js)
  const esc = window.lgEscapeHtml || function(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  };

  // DOM elements cache
  let drawerEl, overlayEl, closeBtnEl, countBubbleEl, itemsEl, emptyEl, loaderEl, headerBubbleEl;

  // Retrieve current wishlist items from localStorage
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  // Save wishlist items to localStorage and trigger sync events
  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new Event('lg:wishlist:updated'));
  }

  // Initialize DOM elements
  function initDOM() {
    drawerEl = document.getElementById('lg-wishlist-drawer');
    overlayEl = document.getElementById('lg-wishlist-drawer-overlay');
    closeBtnEl = document.getElementById('lg-wishlist-drawer-close');
    itemsEl = document.getElementById('lg-wishlist-items');
    emptyEl = document.getElementById('lg-wishlist-empty');
    loaderEl = document.getElementById('lg-wishlist-drawer-loader');
    
    // Header bubble element
    headerBubbleEl = document.getElementById('wishlist-icon-bubble');
    if (headerBubbleEl) {
      countBubbleEl = headerBubbleEl.querySelector('.wishlist-count-bubble');
      headerBubbleEl.addEventListener('click', function(e) {
        e.preventDefault();
        openWishlistDrawer();
      });
    }

    if (closeBtnEl) {
      closeBtnEl.addEventListener('click', closeWishlistDrawer);
    }

    if (overlayEl) {
      overlayEl.addEventListener('click', closeWishlistDrawer);
    }

    // Register click interceptor on document body to handle any wishlist button clicks dynamically
    document.body.addEventListener('click', handleWishlistClick);

    // Sync views on update
    window.addEventListener('lg:wishlist:updated', updateViews);

    // Initial update
    updateViews();

    // Check if there are shared favorites to import from URL
    checkWishlistImport();
  }

  // Open the Wishlist drawer
  function openWishlistDrawer() {
    if (drawerEl && overlayEl) {
      drawerEl.classList.add('open');
      overlayEl.classList.add('open');
      drawerEl.setAttribute('aria-hidden', 'false');
      drawerEl.removeAttribute('inert');
      overlayEl.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden'); // Prevent background scroll
    }
  }

  // Close the Wishlist drawer
  function closeWishlistDrawer() {
    if (drawerEl && overlayEl) {
      drawerEl.classList.remove('open');
      overlayEl.classList.remove('open');
      drawerEl.setAttribute('aria-hidden', 'true');
      drawerEl.setAttribute('inert', '');
      overlayEl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }
  }

  // Handle wishlist button clicks (delegated)
  function handleWishlistClick(e) {
    const button = e.target.closest('.lg-wishlist-btn-toggle, .lg-wishlist-card-btn');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = button.dataset.id;
    const productHandle = button.dataset.handle;
    const productTitle = button.dataset.title;
    const productImage = button.dataset.image;
    const productPrice = button.dataset.price;
    const productUrl = button.dataset.url;

    if (!productHandle) return;

    let wishlist = getWishlist();
    const existingIndex = wishlist.findIndex(item => item.handle === productHandle);

    if (existingIndex > -1) {
      // Remove item (silent state toggle, no toast)
      wishlist.splice(existingIndex, 1);
      saveWishlist(wishlist);
    } else {
      // Add item
      wishlist.push({
        id: productId,
        handle: productHandle,
        title: productTitle,
        image: productImage,
        price: productPrice,
        url: productUrl
      });
      saveWishlist(wishlist);
      animateWishlistAdd(button); // Trigger sophisticated fly & burst animation
    }
  }

  // Simple toast helper in case comparison toast is not loaded
  function showCompareToast(message) {
    // Rely on global compare toast if available
    if (window.showCompareToast) {
      window.showCompareToast(message);
      return;
    }

    let toastContainer = document.getElementById('lg-compare-toast-container');
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.id = 'lg-compare-toast-container';
      toastContainer.style.cssText = 'position: fixed; bottom: 24px; right: 24px; z-index: 10000; display: flex; flex-direction: column; gap: 8px; pointer-events: none;';
      document.body.appendChild(toastContainer);
    }

    const toast = document.createElement('div');
    toast.style.cssText = [
      'background: #ffffff',
      'color: rgba(8,12,20,0.85)',
      'padding: 12px 20px',
      'border-radius: 0',
      'border: 1px solid rgba(8,12,20,0.08)',
      'border-left: 3px solid #F8900B',
      'font-size: 1.2rem',
      'font-weight: 400',
      'font-family: var(--font-body-family, sans-serif)',
      'letter-spacing: 0.03em',
      'box-shadow: 0 4px 20px rgba(0,0,0,0.06)',
      'display: flex',
      'align-items: center',
      'gap: 10px',
      'opacity: 0',
      'transform: translateY(8px)',
      'transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.16,1,0.3,1)',
      'pointer-events: auto',
      'min-width: 200px',
      'max-width: 320px'
    ].join('; ');
    toast.innerHTML = `
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F8900B" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0; margin-right: 4px;">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      <span>${esc(message)}</span>
    `;
    toastContainer.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    }, 10);

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-6px)';
      setTimeout(() => toast.remove(), 350);
    }, 2800);
  }

  // Sync state with DOM, classes, and render list in drawer
  function updateViews() {
    const wishlist = getWishlist();
    const count = wishlist.length;

    // 1. Update Header Bubble
    if (countBubbleEl) {
      if (count > 0) {
        countBubbleEl.textContent = count;
        countBubbleEl.style.display = 'flex';
      } else {
        countBubbleEl.style.display = 'none';
      }
    }

    // 2. Update toggle buttons state (active class)
    document.querySelectorAll('.lg-wishlist-btn-toggle, .lg-wishlist-card-btn').forEach(btn => {
      const handle = btn.dataset.handle;
      if (wishlist.some(item => item.handle === handle)) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        if (btn.classList.contains('lg-wishlist-btn-toggle')) {
          const textSpan = btn.querySelector('span');
          if (textSpan) textSpan.textContent = 'En Favoritos';
        }
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
        if (btn.classList.contains('lg-wishlist-btn-toggle')) {
          const textSpan = btn.querySelector('span');
          if (textSpan) textSpan.textContent = 'Favoritos';
        }
      }
    });

    // 3. Update count badge in drawer header
    const countBadgeEl = document.getElementById('lg-wishlist-count-badge');
    if (countBadgeEl) {
      countBadgeEl.textContent = count === 1 ? '1 artículo' : `${count} artículos`;
    }

    // 4. Update sharing footer in drawer
    const footerEl = document.getElementById('lg-wishlist-drawer-footer');
    if (footerEl) {
      if (count > 0) {
        footerEl.style.display = 'block';
        setupSharing(wishlist);
      } else {
        footerEl.style.display = 'none';
      }
    }

    // 5. Render items in drawer
    renderDrawerItems(wishlist);
  }

  // Render items inside the drawer list
  function renderDrawerItems(wishlist) {
    if (!itemsEl) return;

    itemsEl.innerHTML = '';

    if (wishlist.length === 0) {
      if (emptyEl) emptyEl.style.display = 'flex';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    wishlist.forEach(item => {
      const itemRow = document.createElement('div');
      itemRow.className = 'lg-wishlist-item';
      itemRow.dataset.handle = item.handle;

      itemRow.innerHTML = `
        <div class="lg-wishlist-item__image-wrap">
          <a href="${esc(item.url || '#')}">
            <img src="${esc(item.image || 'data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'80\' height=\'80\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23F8900B\'><circle cx=\'12\' cy=\'12\' r=\'10\'/></svg>')}" alt="${esc(item.title)}" loading="lazy">
          </a>
        </div>
        <div class="lg-wishlist-item__info">
          <div>
            <h3 class="lg-wishlist-item__title">
              <a href="${esc(item.url || '#')}">${esc(item.title)}</a>
            </h3>
            <p class="lg-wishlist-item__price">${esc(item.price || '')}</p>
          </div>
          <div class="lg-wishlist-item__actions">
            <a href="${esc(item.url || '#')}" class="lg-wishlist-item__btn-view">Ver Producto</a>
          </div>
        </div>
        <button type="button" class="lg-wishlist-item__remove" aria-label="Quitar de favoritos" data-handle="${item.handle}">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      `;

      // Remove button listener
      const removeBtn = itemRow.querySelector('.lg-wishlist-item__remove');
      removeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        let currentList = getWishlist();
        currentList = currentList.filter(i => i.handle !== item.handle);
        saveWishlist(currentList);
      });

      itemsEl.appendChild(itemRow);
    });
  }

  // Sophisticated fly to header heart animation
  function animateWishlistAdd(button) {
    const headerHeart = document.getElementById('wishlist-icon-bubble');
    if (!headerHeart) return;

    // Burst golden particles around the button
    createParticleBurst(button);

    // Get bounds
    const btnRect = button.getBoundingClientRect();
    const heartRect = headerHeart.getBoundingClientRect();

    // Create floating flyer heart element
    const flyer = document.createElement('div');
    flyer.className = 'lg-wishlist-flyer';
    flyer.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="#f8900b" stroke="#f8900b" stroke-width="1.5">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
      </svg>
    `;
    
    // Position fixed to viewport at click source
    flyer.style.left = `${btnRect.left + btnRect.width / 2 - 12}px`;
    flyer.style.top = `${btnRect.top + btnRect.height / 2 - 12}px`;
    document.body.appendChild(flyer);

    // Force style recalculation
    void flyer.offsetWidth;

    // Trigger translate-scale transition toward target heart icon
    requestAnimationFrame(() => {
      const deltaX = heartRect.left - btnRect.left;
      const deltaY = heartRect.top - btnRect.top;
      flyer.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.2)`;
      flyer.style.opacity = '0.2';
    });

    flyer.addEventListener('transitionend', () => {
      flyer.remove();
      // Add dynamic pulse bounce animation on header heart
      headerHeart.classList.remove('lg-pulse-active');
      void headerHeart.offsetWidth; // Trigger reflow
      headerHeart.classList.add('lg-pulse-active');
      setTimeout(() => {
        headerHeart.classList.remove('lg-pulse-active');
      }, 600);
    });
  }

  // Create burst of golden and dark gold particles on click
  function createParticleBurst(button) {
    const rect = button.getBoundingClientRect();
    const burstCount = 12;
    
    for (let i = 0; i < burstCount; i++) {
      const particle = document.createElement('span');
      particle.className = 'lg-wishlist-particle';
      
      const isSparkle = Math.random() > 0.5;
      particle.innerHTML = isSparkle ? '✦' : '❤';
      particle.style.color = isSparkle ? '#f8900b' : '#a15e07';
      particle.style.fontSize = `${Math.random() * 8 + 10}px`;
      
      particle.style.left = `${rect.left + rect.width / 2}px`;
      particle.style.top = `${rect.top + rect.height / 2}px`;
      document.body.appendChild(particle);

      const angle = Math.random() * Math.PI * 2;
      const distance = Math.random() * 50 + 20;
      const destX = Math.cos(angle) * distance;
      const destY = Math.sin(angle) * distance;

      void particle.offsetWidth;

      requestAnimationFrame(() => {
        particle.style.transform = `translate(${destX}px, ${destY}px) scale(0)`;
        particle.style.opacity = '0';
      });

      particle.addEventListener('transitionend', () => {
        particle.remove();
      });
    }
  }

  // Setup social sharing link parameters
  function setupSharing(wishlist) {
    const handles = wishlist.map(item => encodeURIComponent(item.handle)).join(',');
    const shareUrl = window.location.origin + window.location.pathname + '?wishlist=' + handles;

    const whatsappBtn = document.getElementById('lg-share-whatsapp');
    const emailBtn = document.getElementById('lg-share-email');
    const copyBtn = document.getElementById('lg-share-copy');

    if (whatsappBtn) {
      whatsappBtn.href = 'https://api.whatsapp.com/send?text=' + encodeURIComponent('¡Hola! Echa un vistazo a mi lista de favoritos de LuzGuru: ' + shareUrl);
    }

    if (emailBtn) {
      emailBtn.href = 'mailto:?subject=' + encodeURIComponent('Mis favoritos en LuzGuru') + '&body=' + encodeURIComponent('Hola,\n\nQuería compartir contigo mi lista de productos favoritos de LuzGuru. Puedes verlos en el siguiente enlace:\n\n' + shareUrl);
    }

    if (copyBtn) {
      // Re-bind click listener to avoid accumulation
      const newCopyBtn = copyBtn.cloneNode(true);
      copyBtn.parentNode.replaceChild(newCopyBtn, copyBtn);
      
      newCopyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        navigator.clipboard.writeText(shareUrl).then(() => {
          const tooltip = document.getElementById('lg-copy-tooltip');
          if (tooltip) {
            tooltip.textContent = '¡Copiado!';
            newCopyBtn.classList.add('copied');
            setTimeout(() => {
              tooltip.textContent = 'Copiar Enlace';
              newCopyBtn.classList.remove('copied');
            }, 2000);
          }
        });
      });
    }
  }

  // Parse and import shared wishlist handles from URL parameter
  function checkWishlistImport() {
    const params = new URLSearchParams(window.location.search);
    const wishlistParam = params.get('wishlist');
    if (!wishlistParam) return;

    // Clean URL query parameters immediately
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);

    const handlesToImport = wishlistParam.split(',').map(h => h.trim()).filter(Boolean);
    if (handlesToImport.length === 0) return;

    let wishlist = getWishlist();
    let importedCount = 0;
    const fetchPromises = [];

    handlesToImport.forEach(handle => {
      // Avoid importing duplicate items
      if (wishlist.some(item => item.handle === handle)) return;

      const promise = fetch('/products/' + handle + '.js')
        .then(res => {
          if (!res.ok) throw new Error();
          return res.json();
        })
        .then(prod => {
          let formattedPrice = '';
          if (prod.price) {
            formattedPrice = (prod.price_varies ? 'Desde ' : '') + (prod.price / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
          }

          wishlist.push({
            id: prod.id,
            handle: prod.handle,
            title: prod.title,
            image: prod.featured_image || '',
            price: formattedPrice,
            url: prod.url
          });
          importedCount++;
        })
        .catch(() => {
          console.warn('Skipping import for invalid handle: ' + handle);
        });
      fetchPromises.push(promise);
    });

    if (fetchPromises.length > 0) {
      Promise.all(fetchPromises).then(() => {
        if (importedCount > 0) {
          saveWishlist(wishlist);
          showImportBanner(importedCount);
        }
      });
    }
  }

  // Show floating import banner alert
  function showImportBanner(count) {
    // Prevent duplicates
    const oldBanner = document.getElementById('lg-wishlist-import-banner');
    if (oldBanner) oldBanner.remove();

    const banner = document.createElement('div');
    banner.id = 'lg-wishlist-import-banner';
    banner.className = 'lg-wishlist-import-banner';
    banner.innerHTML = `
      <div class="lg-wishlist-import-banner__content">
        <span class="lg-wishlist-import-banner__sparkle">✦</span>
        <span>Hemos añadido <strong>${count}</strong> favoritos compartidos a tu lista.</span>
      </div>
      <div class="lg-wishlist-import-banner__actions">
        <button type="button" id="lg-import-banner-open" class="lg-import-banner__btn">Ver Favoritos</button>
        <button type="button" id="lg-import-banner-close" class="lg-import-banner__close" aria-label="Cerrar banner">×</button>
      </div>
    `;

    document.body.appendChild(banner);

    // Trigger transition
    void banner.offsetWidth;
    banner.classList.add('visible');

    const openBtn = banner.querySelector('#lg-import-banner-open');
    const closeBtn = banner.querySelector('#lg-import-banner-close');

    if (openBtn) {
      openBtn.addEventListener('click', () => {
        banner.classList.remove('visible');
        setTimeout(() => banner.remove(), 400);
        openWishlistDrawer();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        banner.classList.remove('visible');
        setTimeout(() => banner.remove(), 400);
      });
    }

    // Auto dismiss after 8 seconds
    setTimeout(() => {
      if (banner.parentNode) {
        banner.classList.remove('visible');
        setTimeout(() => banner.remove(), 400);
      }
    }, 8000);
  }

  // Initialize system when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDOM);
  } else {
    initDOM();
  }
})();
